module.exports = __webpack_public_path__ + "media/images/dashboards/opioid-e1b823f1ac809942d1873efabd6d97fb.png";